export const THEME_KEY = "Dodam_theme" as const;